export function getApplicablePrice({ priceList, selectedUomId, sPriceListId, businessDate = new Date(), alternateUom = [], primaryUomId = null }) {
  if (!Array.isArray(priceList) || priceList.length === 0) return null;

  const today = new Date(businessDate);
  today.setHours(0, 0, 0, 0);

  // Helper: sort latest date first (future also allowed)
  const sortByLatestDate = (arr) =>
    arr
      .map((p) => ({
        ...p,
        effectiveDate: p.effectiveFrom ? new Date(p.effectiveFrom) : null,
      }))
      .sort((a, b) => {
        if (!a.effectiveDate && !b.effectiveDate) return 0;
        if (!a.effectiveDate) return 1;
        if (!b.effectiveDate) return -1;
        return b.effectiveDate - a.effectiveDate;
      });

  // 🔹 STEP 1: PriceList + UOM + Date
  let step1 = priceList.filter((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && p.uomId === selectedUomId && p.effectiveFrom);

  if (step1.length > 0) {
    return sortByLatestDate(step1)[0];
  }

  // 🔹 STEP 2: PriceList + UOM (no date)
  let step2 = priceList.find((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && p.uomId === selectedUomId && !p.effectiveFrom);

  if (step2) return step2;

  if (alternateUom?.length > 0 && selectedUomId) {
    const altUomEntry = alternateUom.find((a) => a.csUomId === selectedUomId);

    if (altUomEntry && altUomEntry.convertionRate) {
      // Find base price (KG / primary UOM price from pricelist)
      const basePrice =
        priceList.find((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && p.uomId === primaryUomId && !p.effectiveFrom) ||
        priceList.find((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && !p.uomId && !p.effectiveFrom) ||
        sortByLatestDate(priceList.filter((p) => !sPriceListId || p.sPricelistId === sPriceListId))[0];

      if (basePrice) {
        const derivedPricestd = parseFloat((parseFloat(basePrice.pricestd) * parseFloat(altUomEntry.convertionRate)).toFixed(4));
        // Return a synthetic price entry shaped like a real pricelist entry
        return {
          ...basePrice,
          uomId: selectedUomId,
          pricestd: derivedPricestd,
          pricelist: derivedPricestd,
          _derived: true, // optional flag for debugging
        };
      }
    }
  }

  // 🔹 STEP 3: PriceList only (latest date)
  let step3 = priceList.filter((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && p.effectiveFrom);

  if (step3.length > 0) {
    return sortByLatestDate(step3)[0];
  }

  // 🔹 STEP 4: PriceList (no date)
  let step4 = priceList.filter((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && !p.effectiveFrom);

  if (step4.length > 0) {
    return sortByLatestDate(step4)[0];
  }

  // 🔹 STEP 5: Any UOM match (latest date)
  let step5 = priceList.filter((p) => p.uomId === selectedUomId && p.effectiveFrom);

  if (step5.length > 0) {
    return sortByLatestDate(step5)[0];
  }

  // 🔹 STEP 6: Default (no UOM, no date)
  return priceList.find((p) => !p.uomId && !p.effectiveFrom) || null;
}
